import React from "react"

import logo from 'Assets/images/logo.png'
import {Col, Row} from "react-bootstrap";
import {LoginSquare} from "./LoginSquare";
import {Link} from "react-router-dom";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {useIsDesktop} from "Hooks/Window/ResizeHook";
import Triptico from "../Triptico";

export const Header: React.FC = () => {

    const isDesktop = useIsDesktop()

    return (
        <>
            <Row className={"pt-4 header"}>
                <Col>
                    <Link to={ROUTE_PATHS.LOGIN}>
                        <img src={logo} title={"Sanse Concilia"} alt={"Logo"}/>
                    </Link>
                </Col>
                {
                    isDesktop &&
                    <Col className={"d-flex"}>
                        <Col xl={6} lg={4} sm={12} className={"d-flex justify-content-end align-items-center"}>
                            <Triptico/>
                        </Col>
                        <Col xl={6} lg={8} sm={12} className={"d-flex justify-content-end align-items-center"}>
                            <LoginSquare/>
                        </Col>
                    </Col>
                }
            </Row>
        </>
    )
}
